import { gql } from "@apollo/client";

//mutation para que el usuario se loggee
export const LOGIN = gql`
  mutation login($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      token
    }
  }
`;

//mutation RecoveryCode
export const RECOVERY_CODE = gql`
  mutation RecoveryCode($username: String!, $email: String!) {
    recoveryCode(username: $username, email: $email) {
      status
    }
  }
`;
//mutation change password
export const CHANGE_PASSWORD = gql`
  mutation ChangePassword(
    $username: String!
    $recoveryCode: String!
    $newPassword: String!
  ) {
    changePassword(
      username: $username
      recovery_code: $recoveryCode
      new_password: $newPassword
    ) {
      status
    }
  }
`;

//query para traer el username
export const GET_USERNAME = gql`
  query user($user_id: String!) {
    user(user_id: $user_id) {
      username
    }
  }
`;
//query para traerme el user con el que me logueo
export const GET_USER = gql`
  query User($user_id: String!) {
    user(user_id: $user_id) {
      user_id
      username
      email
      belong_id
      type
      assigned_to
      mono
    }
  }
`;

//query para traer las branches y mas info de la compañia
export const GET_COMPANY_DETAIL = gql`
  query Company($companyId: String) {
    company(company_id: $companyId) {
      company_id
      name
      location
      branches {
        branch_id
        name
        address
        type
        owned
        created
        last_modified
        status
      }
      operators {
        operator_id
        name
        code
        mail
        created
        last_modified
        status
        access_to {
          send
          receive
          checkpoint
          calibrate
          recursive
          geolocation
          dash_report
          dash_intransit
          dash_control
        }
        type
      }
      free_operators {
        operator_id
        name
        code
        mail
        created
        last_modified
        status
        access_to {
          send
          receive
          checkpoint
          calibrate
          recursive
          geolocation
          dash_report
          dash_intransit
          dash_control
        }
        type
      }
      billing
      contact_info
      created
      last_modified
      status
      distributor_id
      users_id
      barcode
      bra_counter
      ope_counter
      shi_counter
      ref_counter
      cal_counter
      alert_params {
        temperature_alerts {
          name
          max
          min
        }
        acceleration_alerts {
          name
          value
        }
      }
      custom_checks {
        name
        mandatory
        behavior
      }
      sense_frequency
      default_frequency
      language
      gmt
      hired_services
      notifications
      startup_alerts
      tolerance {
        time
        temp
      }
    }
  }
`;

export const GET_COMPANY_DETAIL_BRANCHES = gql`
  query Company($companyId: String) {
    company(company_id: $companyId) {
      company_id
      branches {
        branch_id
        name
        address
        type
        owned
        created
        last_modified
        status
      }
    }
  }
`;

//traer opes
export const GET_COMPANY_OPES = gql`
  query Query($company_id: String) {
    company(company_id: $company_id) {
      operators {
        operator_id
        name
        code
        mail
        created
        last_modified
        status
        access_to {
          send
          receive
          checkpoint
          recursive
          calibrate
          dash_report
          dash_intransit
          dash_control
          recursive
          geolocation
        }
        type
      }
    }
  }
`;
//traigo responsibles

//traigo alertparams
export const GET_COMPANY_ALERT_PARAMS = gql`
  query Query($companyId: String) {
    company(company_id: $companyId) {
      alert_params {
        temperature_alerts {
          name
          max
          min
        }
        acceleration_alerts {
          name
          value
        }
      }
    }
  }
`;
//query para traer los content de un shipment
export const GET_SHIPMENT_DETAIL = gql`
  query shipment($shipment_id: String) {
    shipment(shipment_id: $shipment_id) {
      _id
      shipment_id
      origin_id
      destination_id
      departure
      arrival
      status
      origin_op_id
      destination_op_id
      type
      checkpoints {
        responsible_id
        responsible_name
        location
        timestamp
        temperature
        label
        hall
      }
      last_checkpoint {
        label
        location
        location_id
        responsible_id
        responsible_name
        temperature
        timestamp
        hall
      }
      temperature_readings {
        value
        timestamp
        counter
        cv
      }
      temperature_range {
        name
        max
        min
      }
      acceleration {
        x
        y
        z
        timestamp
        counter
      }

      contents {
        id
      }
      intrusions {
        init_counter
        final_counter
        init_timestamp
        final_timestamp
      }
      alerts {
        value
        type
        timestamp
      }
      comments {
        text
        author
        timestamp
      }
    }
  }
`;

//query para traer los content de un shipment
export const GET_SHIPMENT_COMMENTS = gql`
  query shipment($shipment_id: String) {
    shipment(shipment_id: $shipment_id) {
      shipment_id
      origin_id
      destination_id
      departure
      arrival
      origin_op_id
      comments {
        text
        author
        date
      }
    }
  }
`;

//query para traer shipment por qr

export const GET_SHIPMENTS = gql`
  query shipments($in_transit: Boolean!) {
    shipment(in_transit: $in_transit) {
      selectedItems {
        _id
        shipment_id
        company_id
        qr
      }
    }
  }
`;

//query para traerme shipments paginados
export const GET_SHIPMENTS_PAG = gql`
  query shipments(
    $in_transit: Boolean!
    $company_id: String
    $status: ShipStatus
    $from_date: Date
    $to_date: Date
    $origin_id: String
    $origin_op_id: String
    $destination_id: String
    $destination_op_id: String
    $item_id: String
    $qr: String
    $page: Int
    $per_page: Int
    $shipment_ids: [String!]
    $temperature_range: String
  ) {
    shipments(
      in_transit: $in_transit
      company_id: $company_id
      status: $status
      from_date: $from_date
      to_date: $to_date
      origin_id: $origin_id
      origin_op_id: $origin_op_id
      destination_id: $destination_id
      destination_op_id: $destination_op_id
      item_id: $item_id
      qr: $qr
      page: $page
      per_page: $per_page
      shipment_ids: $shipment_ids
      temperature_range: $temperature_range
    ) {
      total
      per_page
      page
      selectedItems {
        _id
        shipment_id
        company_id
        unique_shipment_id
        shippers_id
        qr
        type
        temperature_readings {
          value
          cv
          timestamp
          counter
        }
        acceleration {
          x
          y
          z
          timestamp
          counter
        }
        intrusions {
          init_counter
          init_timestamp
          final_counter
          final_timestamp
        }
        intrusion
        battery_level {
          departure
          arrival
        }
        alerts {
          type
          value
          x
          y
          z
          timestamp
        }
        alerts_flags
        origin_id
        origin_op_id
        destination_id
        destination_op_id
        contents {
          id
        }
        departure
        arrival
        status
        checkpoints {
          responsible_id
          responsible_name
          timestamp
          location
          temperature
          battery_level
          label
        }
        last_checkpoint {
          responsible_id
          responsible_name
          timestamp
          location
          location_id
          temperature
          battery_level
          label
        }
        last_geolocation {
          geo_id
          lng
          lat
          timestamp
          temperature
          intrusion
        }
        comments {
          text
          author
          date
        }
        temperature_range {
          name
          max
          min
        }
        offset
      }
    }
  }
`;
//shipments to header report table
export const GET_SHIPMENTS_PAG_TO_HEADER = gql`
  query shipments(
    $in_transit: Boolean!
    $company_id: String
    $status: ShipStatus
    $from_date: Date
    $to_date: Date
    $origin_id: String
    $origin_op_id: String
    $destination_id: String
    $destination_op_id: String
    $item_id: String
    $qr: String
    $page: Int
    $per_page: Int
    $shipment_ids: [String!]
    $branch_id: String
    $operator_id: String
    $temperature_range: String
  ) {
    shipments(
      in_transit: $in_transit
      company_id: $company_id
      status: $status
      from_date: $from_date
      to_date: $to_date
      origin_id: $origin_id
      origin_op_id: $origin_op_id
      destination_id: $destination_id
      destination_op_id: $destination_op_id
      item_id: $item_id
      qr: $qr
      page: $page
      per_page: $per_page
      shipment_ids: $shipment_ids
      branch_id: $branch_id
      operator_id: $operator_id
      temperature_range: $temperature_range
    ) {
      total
      per_page
      page
      selectedItems {
        _id
        shipment_id
        company_id
        unique_shipment_id
        shippers_id
        qr
        type
        origin_id
        origin_op_id
        destination_id
        destination_op_id
        departure
        arrival
        status
        checkpoints {
          responsible_id
          responsible_name
          timestamp
          location
          temperature
          battery_level
          label
        }
        temperature_range {
          name
          max
          min
        }
        offset
      }
    }
  }
`;
//query para traer shipments y asociarlo con devices

export const GET_SHIPMENTS_PAG2 = gql`
  query shipments(
    $in_transit: Boolean!
    $company_id: String
    $from_date: Date
    $to_date: Date
    $status: ShipStatus
    $origin_id: String
    $origin_op_id: String
    $destination_id: String
    $destination_op_id: String
    $item_id: String
    $page: Int
    $per_page: Int
  ) {
    shipments(
      in_transit: $in_transit
      company_id: $company_id
      from_date: $from_date
      to_date: $to_date
      status: $status
      origin_id: $origin_id
      origin_op_id: $origin_op_id
      destination_id: $destination_id
      destination_op_id: $destination_op_id
      item_id: $item_id
      page: $page
      per_page: $per_page
    ) {
      total
      selectedItems {
        qr: qr
        shipment_id
        _id
      }
    }
  }
`;
//query para  comparar shipments
export const GET_SHIPMENTS_TO_COMPARE = gql`
  query ShipmentsToCompare($shipments_ids: [String!]!, $company_id: String!) {
    shipmentsToCompare(shipments_ids: $shipments_ids, company_id: $company_id) {
      shipment_id
      _id
      temperature_readings {
        value
        timestamp
        counter
        cv
      }
    }
  }
`;
//para comparar calibraciones
export const GET_CALIBRATIONS_TO_COMPARE = gql`
  query CalibrationsToCompare(
    $calibrations_id: [String!]!
    $company_id: String!
  ) {
    calibrationsToCompare(
      calibrations_id: $calibrations_id
      company_id: $company_id
    ) {
      calibration_id
      temperature_readings {
        counter
        cv
        timestamp
        value
      }
    }
  }
`;
//subscription para viajes creados
export const SHIPMENTS_CREATED_SUBSCRIPTION = gql`
  subscription {
    shipmentAdded {
      shipment_id
      status
      qr
      departure
      last_checkpoint {
        location
        responsible_name
        timestamp
        temperature
        battery_level
      }
    }
  }
`;

//subscription para viajes cerrados
export const SHIPMENTS_UPDATED_SUBSCRIPTION = gql`
  subscription {
    shipmentUpdated {
      shipment_id
      status
      qr
      departure
      arrival
      origin_id
      alerts {
        type
      }
    }
  }
`;

//subscription para checkpoints
export const SHIPMENTS_CHECKPOINTS_SUBSCRIPTION = gql`
  subscription ShipmentChecked {
    shipmentChecked {
      battery_level {
        departure
        arrival
      }
      checkpoints {
        responsible_id
        responsible_name
        timestamp
        location
        temperature
        battery_level
        label
      }
      last_checkpoint {
        responsible_id
        responsible_name
        timestamp
        location
        location_id
        temperature
        battery_level
        label
      }

      departure
      destination_id
      destination_op_id
      origin_id
      origin_op_id
      qr
      shipment_id
      shippers_id
      status
      type
      unique_shipment_id
    }
  }
`;

//query para trae mis usuarios
export const GET_ALL_USERS = gql`
  query users($belong_id: String) {
    users(belong_id: $belong_id) {
      belong_id
      user_id
      username
      email
      type
      assigned_to
      status
      mono
    }
  }
`;

//query para traerme todos los dispositivos
export const GET_DEVICES = gql`
  query devices($assigned_to: String) {
    devices(assigned_to: $assigned_to) {
      device_id
      _id
      qr
      battery_level
      assigned_to
      last_service
      last_location
      last_use
      sensors
      device_format
      status
      version
      calibrations {
        calibrator_id
        issue_date
        due_date
        # slope
        # y_intercept
        report_id
        thermometer_id
      }
      temperature_range {
        max
        min
        name
      }
    }
  }
`;

//query para traerme todos los dispositivos
export const GET_DEVICES_QUANTITY = gql`
  query devices($assigned_to: String) {
    devices(assigned_to: $assigned_to) {
      _id
      device_id
    }
  }
`;

//query para editar los datos de la compañia
export const UPDATE_COMPANY = gql`
  mutation UpdateCompany(
    $company_id: String
    $name: String
    $location: String
    $billing: String
    $contact_info: String
    $status: Status
    $barcode: [Barcode]
    $distributor_id: String
    $alertParams: AlertParamsInput
    $sense_frequency: [Int!]
    $custom_checks: [CustomCheckInput!]
    $language: Language
    $gmt: String
    $hired_services: [Service!]
    $notifications: Boolean
    $tolerance: ToleranceInput
    $startup_alerts: Boolean
  ) {
    updateCompany(
      company_id: $company_id
      name: $name
      location: $location

      billing: $billing
      contact_info: $contact_info
      status: $status
      barcode: $barcode
      distributor_id: $distributor_id
      alert_params: $alertParams
      sense_frequency: $sense_frequency
      custom_checks: $custom_checks
      language: $language
      gmt: $gmt
      hired_services: $hired_services
      notifications: $notifications
      tolerance: $tolerance
      startup_alerts: $startup_alerts
    ) {
      users_id
      status
      shi_counter
      sense_frequency

      ope_counter
      name
      location
      last_modified
      language
      gmt
      free_operators {
        operator_id
        name
        code
        mail
        created
        last_modified
        status
        access_to {
          send
          receive
          checkpoint
          calibrate
          recursive
          geolocation
          dash_report
          dash_intransit
          dash_control
        }
        type
      }
      distributor_id
      custom_checks {
        name
        mandatory
      }
      created
      contact_info
      company_id

      bra_counter
      billing
      barcode
      alert_params {
        temperature_alerts {
          name
          max
          min
        }
        acceleration_alerts {
          name
          value
        }
      }
    }
  }
`;
export const UPDATE_TEMP_ALERT_PARAMS = gql`
  mutation UpdateCompany($company_id: String, $alert_params: AlertParamsInput) {
    updateCompany(company_id: $company_id, alert_params: $alert_params) {
      company_id
      alert_params {
        temperature_alerts {
          max
          min
          name
        }
      }
    }
  }
`;
export const UPDATE_ACC_ALERT_PARAMS = gql`
  mutation UpdateCompany($company_id: String, $alert_params: AlertParamsInput) {
    updateCompany(company_id: $company_id, alert_params: $alert_params) {
      company_id
      alert_params {
        acceleration_alerts {
          name
          value
        }
      }
    }
  }
`;

//query para editar los datos de la compañia siendo sudo
export const UPDATE_COMPANY_SUDO = gql`
  mutation UpdateCompany(
    $company_id: String
    $name: String
    $location: String
    $billing: String
    $contact_info: String
    $status: Status!
    $barcode: [Barcode]
    $distributor_id: String
    $alert_arams: AlertParamsInput
  ) {
    updateCompany(
      company_id: $company_id
      name: $name
      location: $location

      billing: $billing
      contact_info: $contact_info
      status: $status
      barcode: $barcode
      distributor_id: $distributor_id
      alert_params: $alert_params
    ) {
      company_id
      name
      location

      billing
      contact_info
      created
      last_modified
      status
      distributor_id
      users_id
      barcode
      bra_counter
      ope_counter
      shi_counter
      alert_params {
        acceleration_alerts {
          name
          value
        }
        temperature_alerts {
          max
          min
          name
        }
      }
      language
      gmt
    }
  }
`;
//query calibrations
export const GET_CALIBRATIONS = gql`
  query Calibrations(
    $company_id: String
    $page: Int
    $per_page: Int
    $qr: String
    $from: Date
    $to: Date
  ) {
    calibrations(
      company_id: $company_id
      page: $page
      per_page: $per_page
      qr: $qr
      from: $from
      to: $to
    ) {
      total
      selectedItems {
        arrival
        battery_level {
          arrival
          departure
        }
        calibration_id
        company_id
        departure

        operator_id
        qr
        status

        thermometer_ids
        unique_calibration_id
      }
    }
  }
`;
//query calibration
export const GET_CALIBRATION = gql`
  query Calibration($calibration_id: String, $qr: String) {
    calibration(calibration_id: $calibration_id, qr: $qr) {
      acceleration {
        counter
        timestamp
        x
        y
        z
      }
      arrival
      battery_level {
        arrival
        departure
      }
      calibration_id
      company_id
      departure
      intrusion
      intrusions {
        final_counter
        final_timestamp
        init_counter
        init_timestamp
      }
      operator_id
      qr
      status
      temperature_readings {
        counter
        cv
        timestamp
        value
      }
      thermometer_ids
      unique_calibration_id
    }
  }
`;
//mutation para updatear user
export const UPDATE_USER = gql`
  mutation updateUser(
    $user_id: String
    $username: String
    $email: String
    $assigned_to: String
    $status: Status
    $password: ChangePassword
  ) {
    updateUser(
      user_id: $user_id
      username: $username
      email: $email
      assigned_to: $assigned_to
      status: $status
      password: $password
    ) {
      user_id
      username
      email
      type
    }
  }
`;

//mutation para crear user
export const CREATE_USER = gql`
  mutation createUser(
    $belong_id: String!
    $username: String!
    $email: String!
    $role: String!
    $password: String!
  ) {
    createUser(
      belong_id: $belong_id
      username: $username
      email: $email
      role: $role
      password: $password
    ) {
      user_id
      username
    }
  }
`;

//mutation para eliminar usuario
export const DELETE_USER = gql`
  mutation deleteUser($user_id: String!) {
    deleteUser(user_id: $user_id) {
      user_id
    }
  }
`;

//query para traerme todas las compañias
export const GET_COMPANIES = gql`
  query Companies($belong_id: String) {
    companies(belong_id: $belong_id) {
      users_id
      status
      shi_counter
      sense_frequency
      operators {
        operator_id
        name
        code
        mail
        created
        last_modified
        status
        access_to {
          send
          receive
          checkpoint
          calibrate
          recursive
          geolocation
          dash_report
          dash_intransit
          dash_control
        }
        type
      }
      ope_counter
      name
      location
      last_modified
      language
      gmt
      free_operators {
        operator_id
        name
        code
        mail
        created
        last_modified
        status
        access_to {
          send
          receive
          checkpoint
          calibrate
          recursive
          geolocation
          dash_report
          dash_intransit
          dash_control
        }
        type
      }
      distributor_id
      custom_checks {
        name
        mandatory
      }
      created
      contact_info
      company_id
      branches {
        branch_id
        name
        address
        type
        owned
        created
        last_modified
        status
      }
      bra_counter
      billing
      barcode
      alert_params {
        temperature_alerts {
          name
          max
          min
        }
        acceleration_alerts {
          name
          value
        }
      }
    }
  }
`;

//mutation para updatear device
export const UPDATE_DEVICE = gql`
  mutation updateDevice(
    $device_id: String!
    $qr: String
    $battery_level: Float
    $version: Int
    $device_format: DeviceFormat
    $assigned_to: String
    $status: Status
    $temperature_range: String
    $sensors: [Sensor!]
    $was_serviced: Boolean
    $comment_text: CommentInput
  ) {
    updateDevice(
      device_id: $device_id
      qr: $qr
      battery_level: $battery_level
      version: $version
      device_format: $device_format
      assigned_to: $assigned_to
      status: $status
      temperature_range: $temperature_range
      sensors: $sensors
      was_serviced: $was_serviced
      comment_text: $comment_text
    ) {
      device_id
    }
  }
`;

//mutation para crear device
export const CREATE_DEVICE = gql`
  mutation CreateDevice(
    $address: String!
    $qr: String!
    $version: String!
    $device_format: DeviceFormat!
    $sensors: [Sensor!]!
    $assigned_to: String
    $temperature_range: String
    $comment_text: CommentInput
  ) {
    createDevice(
      address: $address
      qr: $qr
      version: $version
      device_format: $device_format
      sensors: $sensors
      assigned_to: $assigned_to
      temperature_range: $temperature_range
      comment_text: $comment_text
    ) {
      device_id
      address
      qr
      battery_level
      battery_usage {
        timestamp
        lvl
      }
      version
      assigned_to
      status
      temperature_range {
        name
        max
        min
      }
      sensors
      device_format
      last_location
      last_service
      last_use
      comments {
        text
        author
        date
      }
    }
  }
`;

//mutation para eliminar device
export const DELETE_DEVICE = gql`
  mutation deleteDevice($device_id: String) {
    deleteDevice(device_id: $device_id) {
      device_id
    }
  }
`;

//mutation para agregar comentario al shipment
export const ADD_COMMENT = gql`
  mutation addComment(
    $shipment_id: String!
    $comment_text: String!
    $timestamp: Date
  ) {
    addComment(
      shipment_id: $shipment_id
      comment_text: $comment_text
      timestamp: $timestamp
    ) {
      shipment_id
    }
  }
`;

//query para traerme todos los distribuidores
export const GET_DISTRIBUTORS = gql`
  query distributors {
    distributors {
      distributor_id
      name
      location
      status
      contact_info
      created
      region
      last_modified
      companies_id
      users_id
    }
  }
`;

//mutation para updatear distribuidor
export const UPDATE_DISTRIBUTOR = gql`
  mutation updateDistributor(
    $distributor_id: String!
    $name: String
    $location: String
    $contact_info: String
    $region: String
    $status: Status!
  ) {
    updateDistributor(
      distributor_id: $distributor_id
      name: $name
      location: $location
      contact_info: $contact_info
      region: $region
      status: $status
    ) {
      distributor_id
    }
  }
`;

//mutation para crear el distribuidor
export const CREATE_DISTRIBUTOR = gql`
  mutation createDistributor(
    $name: String!
    $location: String!
    $contact_info: String!
    $region: String!
  ) {
    createDistributor(
      name: $name
      location: $location
      contact_info: $contact_info
      region: $region
    ) {
      distributor_id
    }
  }
`;

//mutation para eliminar el distribuidor
export const DELETE_DISTRIBUTOR = gql`
  mutation deleteDistributor($distributor_id: String!) {
    deleteDistributor(distributor_id: $distributor_id) {
      distributor_id
    }
  }
`;

//mutation para crear compañia
export const CREATE_COMPANY = gql`
  mutation CreateCompany(
    $name: String!
    $location: String!
    $branches: [BranchInput!]!
    $operators: [OperatorInput!]!
    $billing: String!
    $contact_info: String!
    $distributor_id: String
    $barcode: [Barcode]
    $alert_params: AlertParamsInput
    $sense_frequency: [Int!]
    $language: Language
    $gmt: String
    $hired_services: [Service!]
  ) {
    createCompany(
      name: $name
      location: $location
      branches: $branches
      operators: $operators
      billing: $billing
      contact_info: $contact_info
      distributor_id: $distributor_id
      barcode: $barcode
      alert_params: $alert_params
      sense_frequency: $sense_frequency
      language: $language
      gmt: $gmt
      hired_services: $hired_services
    ) {
      users_id
      status
      shi_counter
      sense_frequency
      operators {
        operator_id
        name
        code
        mail
        created
        last_modified
        status
        access_to {
          send
          receive
          checkpoint
          calibrate
          recursive
          geolocation
          dash_report
          dash_intransit
          dash_control
        }
        type
      }
      ope_counter
      name
      location
      last_modified
      language
      gmt
      free_operators {
        operator_id
        name
        code
        mail
        created
        last_modified
        status
        access_to {
          send
          receive
          checkpoint
          calibrate
          recursive
          geolocation
          dash_report
          dash_intransit
          dash_control
        }
        type
      }
      distributor_id
      custom_checks {
        name
        mandatory
      }
      created
      contact_info
      company_id
      branches {
        branch_id
        name
        address
        type
        owned
        created
        last_modified
        status
      }
      bra_counter
      billing
      barcode
      alert_params {
        temperature_alerts {
          name
          max
          min
        }
        acceleration_alerts {
          name
          value
        }
      }
    }
  }
`;

//mutation para eliminar compañia
export const DELETE_COMPANY = gql`
  mutation deleteCompany($company_id: String!) {
    deleteCompany(company_id: $company_id) {
      company_id
    }
  }
`;
//query para traerme  un device
export const GET_DEVICE = gql`
  query Device($device_id: String, $qr: String, $address: String) {
    device(device_id: $device_id, qr: $qr, address: $address) {
      _id
      calibrations {
        calibrator_id
        coefficients
        due_date
        issue_date
        report_id
        thermometer_id
      }
      qr
    }
  }
`;
//query para traerme los comments de los devices
export const GET_DEVICE_COMMENT = gql`
  query device($device_id: String) {
    device(device_id: $device_id) {
      device_id
      _id
      comments {
        text
        author
        date
      }
    }
  }
`;

//mutation para agregar un comment a un device
export const ADD_DEVICE_COMMENT = gql`
  mutation updateDevice($device_id: String!, $comment_text: CommentInput) {
    updateDevice(device_id: $device_id, comment_text: $comment_text) {
      device_id
    }
  }
`;

//query para traerme los operators no asignados
export const GET_FREE_OPERATORS = gql`
  query freeOperators($belong_id: String, $type: String) {
    freeOperators(belong_id: $belong_id, type: $type) {
      id
      name
    }
  }
`;

//mutation para borrar operadores
export const DELETE_OPERATOR = gql`
  mutation deleteOperator($operator_id: String!) {
    deleteOperator(operator_id: $operator_id) {
      name
    }
  }
`;

//mutation para borrar transportistas
export const DELETE_SHIPPER = gql`
  mutation deleteShipper($shipper_id: String!) {
    deleteShipper(shipper_id: $shipper_id) {
      name
    }
  }
`;

//mutation para borrar calibradores
export const DELETE_CALIBRATOR = gql`
  mutation deleteCalibrator($calibrator_id: String!) {
    deleteCalibrator(calibrator_id: $calibrator_id) {
      name
    }
  }
`;

export const GET_BARCODES = gql`
  query {
    __type(name: "Barcode") {
      name
      enumValues {
        name
      }
    }
  }
`;

//freeze------------------------------//

export const GET_REFRIGERATIONS = gql`
  query Refrigerations(
    $company_id: String
    $name: String
    $from: Date
    $to: Date
    $qr: String
    $type: String
    $solved: Boolean
    $only_new: Boolean
    $page: Int
    $per_page: Int
  ) {
    refrigerations(
      company_id: $company_id
      from: $from
      to: $to
      qr: $qr
      type: $type
      solved: $solved
      only_new: $only_new
      name: $name
      page: $page
      per_page: $per_page
    ) {
      _id
      company_id
      qr
      gmt
      type
      comments {
        author
        date
        text
      }
      interval
      temperature_range {
        max
        min
        name
      }
      refrigeration_id
      unique_refrigeration_id
      upload_time
      wifi_signal
      name
      comments {
        text
        author
      }
      status
      last_reading {
        time
        temp
        cv
      }
      responsible
      alerts {
        type
        value
        x
        y
        z

        timestamp
        solved
        new
        comments {
          text
          author
          date
        }
      }
    }
  }
`;
export const GET_REFRIGERATIONS_QUANTITY = gql`
  query Refrigerations($company_id: String) {
    refrigerations(company_id: $company_id) {
      qr
    }
  }
`;
export const GET_REFRIGERATION = gql`
  query Refrigeration($qr: String!, $from: Date, $to: Date) {
    refrigeration(qr: $qr, from: $from, to: $to) {
      company_id
      gmt
      interval
      qr
      readings {
        temp
        time
        cv
      }
      _id
      refrigeration_id
      type
      unique_refrigeration_id
      upload_time
      wifi_signal
      name
      comments {
        text
        author
        date
        timestamp
      }
      status
      last_reading {
        time
        temp
        cv
      }
      alerts {
        type
        value
        x
        y
        z
        timestamp
        solved

        comments {
          text
          author
          date
        }
      }
      responsible
    }
  }
`;

export const GET_REFRIGERATION_ALERTS = gql`
  query Refrigeration(
    $qr: String!
    $from: Date
    $to: Date
    $page: Int
    $per_page: Int
    $solved: Boolean
  ) {
    refrigeration(
      qr: $qr
      from: $from
      to: $to
      page: $page
      per_page: $per_page
      solved: $solved
    ) {
      company_id
      alerts {
      type
      value
      x
      y
      z
      timestamp
      start
      end
      solved
      comments {
        text
        author
        date
        timestamp
      }
      severity
      new
    }
  

      responsible
      totalAlerts
    }
  }
`;

export const GET_REFRIGERATIONS_TO_SET_NOTIFICATIONS = gql`
  query Refrigerations(
    $company_id: String
    $only_new: Boolean
    $page: Int
    $per_page: Int
  ) {
    refrigerations(
      company_id: $company_id
      only_new: $only_new
      page: $page
      per_page: $per_page
    ) {
      _id
      company_id
      refrigeration_id
      unique_refrigeration_id
    }
  }
`;
export const GET_REFRIGERATION_COMMENTS = gql`
  query Refrigeration($qr: String!, $from: Date, $to: Date) {
    refrigeration(qr: $qr, from: $from, to: $to) {
      _id
      refrigeration_id
      comments {
        author
        timestamp
        date
        text
      }
    }
  }
`;

export const GET_FREE_DEVICES = gql`
  query FreeDevices($company_id: String!, $device_format: DeviceFormat) {
    freeDevices(company_id: $company_id, device_format: $device_format) {
      address
      assigned_to
      battery_level
      battery_usage {
        timestamp
        lvl
      }
      calibrations {
        calibrator_id
        coefficients
        due_date
        issue_date
        report_id
        thermometer_id
      }
      comments {
        text
        author
        date
      }
      device_format
      device_id
      last_location
      last_service
      last_use
      qr
      sensors
      status
      temperature_range {
        name
        max
        min
      }
      token
    }
  }
`;
export const CREATE_REFRIGERATION = gql`
  mutation Mutation(
    $qr: String!
    $type: String!
    $temperature_range: String
    $name: String!
  ) {
    createRefrigeration(
      qr: $qr
      type: $type
      temperature_range: $temperature_range
      name: $name
    ) {
      comments {
        author
        date
        text
      }
      company_id
      gmt
      interval
      last_reading {
        temp
        time
      }
      qr
      readings {
        temp
        time
      }
      refrigeration_id
      temperature_range {
        name
        max
        min
      }
      type
      unique_refrigeration_id
      upload_time
      wifi_signal
      name
      status
    }
  }
`;
export const UPDATE_REFRIGERATION = gql`
  mutation Mutation(
    $refrigeration_id: String!
    $status: Status
    $qr: String
    $type: String
    $temperature_range: String
    $name: String
    $responsible: [String]
  ) {
    updateRefrigeration(
      refrigeration_id: $refrigeration_id
      qr: $qr
      type: $type
      temperature_range: $temperature_range
      name: $name
      status: $status
      responsible: $responsible
    ) {
      gmt
      interval
      last_reading {
        temp
        time
      }
      qr

      refrigeration_id
      temperature_range {
        name
        max
        min
      }
      type
      unique_refrigeration_id
      upload_time
      wifi_signal
      name
      status
    }
  }
`;
export const ADD_REFRIGERATION_COMMENT = gql`
  mutation AddRefrigerationComment(
    $refrigeration_id: String!
    $comment_text: String!
    $timestamp: Date
  ) {
    addRefrigerationComment(
      refrigeration_id: $refrigeration_id
      comment_text: $comment_text
      timestamp: $timestamp
    ) {
      qr
      comments {
        author
        date
        text
      }
    }
  }
`;
export const UPDATE_REFRIGERATION_ALERTS = gql`
  mutation UpdateRefAlert(
    $refrigeration_id: String!
    $alert_type: String!
    $alert_timestamp: String!
    $solved: Boolean
    $add_comment: CommentInput
  ) {
    updateRefAlert(
      refrigeration_id: $refrigeration_id
      alert_type: $alert_type
      alert_timestamp: $alert_timestamp
      solved: $solved
      add_comment: $add_comment
    ) {
      refrigeration_id
      alerts {
        type
        value
        x
        y
        z
        timestamp
        solved
      }
      comments {
        text
        author
        date
      }
      readings {
        temp
        cv
        time
      }
    }
  }
`;
export const UPDATE_MANY_REFRIGERATION_ALERTS = gql`
  mutation UpdateRefrigerationAlerts(
    $refrigeration_id: String!
    $alerts: [UpdateAlertInput!]!
  ) {
    updateRefrigerationAlerts(
      refrigeration_id: $refrigeration_id
      alerts: $alerts
    ) {
      _id
      qr
    }
  }
`;
//calibration device
export const CALIBRATE_DEVICE = gql`
  mutation CalibrateDevice(
    $device_id: String!
    $calibrator_id: String!
    $due_date: Date!
    $first_point: CalibrationPointInput!
    $second_point: CalibrationPointInput!
    $third_point: CalibrationPointInput!
    $report_id: String
    $thermometer_id: String
  ) {
    calibrateDevice(
      device_id: $device_id
      calibrator_id: $calibrator_id
      due_date: $due_date
      first_point: $first_point
      second_point: $second_point
      third_point: $third_point
      report_id: $report_id
      thermometer_id: $thermometer_id
    ) {
      device_id
      qr
      status
      assigned_to
      calibrations {
        calibrator_id
        due_date
        issue_date
        report_id
        thermometer_id
        coefficients
      }
    }
  }
`;
//mutation create branch
export const CREATE_BRANCH = gql`
  mutation CreateBranch($branch: BranchInput!, $companyId: String) {
    createBranch(branch: $branch, company_id: $companyId) {
      company_id
      created
      name
    }
  }
`;
//mutation update branch
export const UPDATE_BRANCH = gql`
  mutation UpdateBranch($branch: UpdateBranchInput!) {
    updateBranch(branch: $branch) {
      status
      branches {
        branch_id
        name
        status
        type
        last_modified
        address
        owned
      }
    }
  }
`;
//mutation delete Branch
export const DELETE_BRANCH = gql`
  mutation DeleteBranch($branch_id: String!) {
    deleteBranch(branch_id: $branch_id) {
      company_id
    }
  }
`;
//mutation create operator
export const CREATE_OPERATOR = gql`
  mutation CreateOperator($operator: OperatorInput!) {
    createOperator(operator: $operator) {
      company_id
    }
  }
`;
//mutation update operator
export const UPDATE_OPERATOR = gql`
  mutation UpdateOperator($operator: UpdateOperatorInput!) {
    updateOperator(operator: $operator) {
      company_id
    }
  }
`;
